export default {
  data: () => ({

    rawData:  [],
    
    chart: null,
    total: null,
    week: null,
    keys: null,
    
    canvasForms:  null,

    cutoff: null,
  }),




  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },
}